import * as React from 'react';

/**
 * Determines visibility of the ClearButton based on props.
 * Supports both React nodes and render functions as `children`.
 */
var useIsClearButtonVisible = function useIsClearButtonVisible(children) {
  return React.useMemo(function () {
    var _children$props, _children;
    if (/*#__PURE__*/React.isValidElement(children)) return (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.isVisible;
    return typeof children === 'function' ? (_children = children()) === null || _children === void 0 || (_children = _children.props) === null || _children === void 0 ? void 0 : _children.isVisible : false;
  }, [children]);
};

export { useIsClearButtonVisible };
//# sourceMappingURL=useIsClearButtonVisible.js.map
